// src/onboarding/OnbPlotPlan.jsx
// Phase 37 — extracted from src/App.jsx (Plan 37-03).

export default function OnbPlotPlan({ areas = [], pins = [], showCompass = true, highlightArea, style }) {
  return (
    <div className="onb-plot" style={style}>
      <svg viewBox="0 0 360 240" className="onb-plot-svg" aria-hidden="true">
        <defs>
          <pattern id="plotHatch" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)">
            <line x1="0" y1="0" x2="0" y2="4" stroke="rgba(60,50,30,0.1)" strokeWidth="1"/>
          </pattern>
          <filter id="plotSoft">
            <feGaussianBlur stdDeviation="0.4"/>
          </filter>
        </defs>

        <g filter="url(#plotSoft)">
          <rect x="140" y="8" width="80" height="36" rx="4"
                fill="#e8dcc4" stroke="#8b6f47" strokeWidth="1.2" opacity="0.9"/>
          <path d="M 135 14 L 180 -2 L 225 14" stroke="#8b6f47" strokeWidth="1.2" fill="#c99f72" opacity="0.7"/>
          <rect x="172" y="30" width="16" height="14" fill="#6b4a2b" opacity="0.6"/>
        </g>
        <text x="180" y="30" className="onb-plot-label" textAnchor="middle" fontSize="9"
              style={{ fontFamily: "'Playfair Display',serif", fontStyle: "italic", fill: "#6b4a2b" }}>home</text>

        {areas.map((a, i) => {
          const isHL = highlightArea === a.name;
          // Phase 31.3 Gap 5 — pending encoding is outline-only (fill:none) +
          // thicker, darker dashed stroke; solid is translucent brand-green fill
          // + thin hairline stroke. Opacity gap widened to 0.35 vs 1.0 so the
          // visual delta between states is unmissable on mobile renders.
          const stroke = a.pending
            ? "rgba(60,50,30,0.6)"                                    // pending: darker brown dash
            : (isHL ? "#2d5a2d" : "rgba(60,50,30,0.35)");              // solid: unchanged
          const strokeW = a.pending ? 2 : (isHL ? 1.8 : 1.2);          // pending: 2px, solid: 1.2 (was 1)
          const fill = a.pending ? "none" : (a.color || "rgba(156,184,115,0.22)");
          const dash = a.pending ? "4 3" : "0";
          const opacity = a.pending ? 0.35 : 1;                        // was 0.55 vs 0.9
          return (
            <g key={i} className={`onb-plot-area${a.pending ? " is-pending" : ""}`}
               style={{ animation: `onb-plot-pop 500ms ${i * 120}ms var(--ease-pop) backwards` }}>
              <path d={a.path} fill={fill} stroke={stroke} strokeWidth={strokeW}
                    strokeDasharray={dash} opacity={opacity}/>
              {a.hatch && <path d={a.path} fill="url(#plotHatch)" opacity="0.5"/>}
              {a.label && (
                <text x={a.lx} y={a.ly} className="onb-plot-label" textAnchor="middle"
                      style={{ fontFamily: "'Playfair Display',serif", fontStyle: "italic", fontSize: '0.625rem',
                               fill: isHL ? "#2d5a2d" : "#4a4a4a" }}>
                  {a.label}
                </text>
              )}
            </g>
          );
        })}

        {areas.length > 0 && (
          <g opacity="0.45">
            <circle cx="180" cy="80" r="4" fill="#c4b090"/>
            <circle cx="180" cy="100" r="4" fill="#c4b090"/>
            <circle cx="180" cy="120" r="4" fill="#c4b090"/>
            <circle cx="180" cy="140" r="4" fill="#c4b090"/>
          </g>
        )}

        {pins.map((p, i) => (
          <g key={i} className="onb-plot-pin"
             style={{ animation: `onb-pin-drop 400ms ${i * 100}ms var(--ease-pop) backwards` }}>
            <circle cx={p.x} cy={p.y + 4} r="3" fill="rgba(60,50,30,0.2)"/>
            <circle cx={p.x} cy={p.y} r="5" fill={p.color || "#d98b5f"} stroke="#fff" strokeWidth="1.5"/>
            {p.label && (
              <text x={p.x + 8} y={p.y + 3} className="onb-plot-label"
                    style={{ fontFamily: "'Lora',serif", fontSize: '0.5625rem', fill: "#2c2c2c" }}>
                {p.label}
              </text>
            )}
          </g>
        ))}

        {showCompass && (
          <g transform="translate(330, 30)" opacity="0.55">
            <circle cx="0" cy="0" r="12" fill="none" stroke="#8b6f47" strokeWidth="0.8"/>
            <path d="M 0 -10 L 3 0 L 0 10 L -3 0 Z" fill="#8b6f47"/>
            <text x="0" y="-14" textAnchor="middle" style={{ fontFamily: "serif", fontSize: 8, fill: "#8b6f47" }}>N</text>
          </g>
        )}
      </svg>
    </div>
  );
}
